import { render, staticRenderFns } from "./ReportPage.vue?vue&type=template&id=63db7952&scoped=true&"
import script from "./ReportPage.vue?vue&type=script&lang=ts&"
export * from "./ReportPage.vue?vue&type=script&lang=ts&"
import style0 from "./ReportPage.vue?vue&type=style&index=0&id=63db7952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db7952",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
